const styles = {
  moreMenu: {
    "&:hover": {
      // ...background.color.primary.dark,
      backgroundColor: "#2470AC !important",
      color: "white"
    }
  },
  disabled: {
    pointerEvents: "none"
  }
};
export default styles;
